import { render, staticRenderFns } from "./ZoneForfaits.vue?vue&type=template&id=308af7d5&scoped=true&"
import script from "./ZoneForfaits.vue?vue&type=script&lang=js&"
export * from "./ZoneForfaits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308af7d5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37556953/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('308af7d5')) {
      api.createRecord('308af7d5', component.options)
    } else {
      api.reload('308af7d5', component.options)
    }
    module.hot.accept("./ZoneForfaits.vue?vue&type=template&id=308af7d5&scoped=true&", function () {
      api.rerender('308af7d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/home/ZoneForfaits.vue"
export default component.exports